// The Link Resolver takes a Prismic document as its argument
export default function(doc) {}
